export default __webpack_public_path__ + "static/media/Sound.30206cff.svg";